import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AdminLayout from './layouts/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Agenda from './pages/Agenda';
import Atencion from './pages/Atencion';
import Clientes from './pages/Clientes';
import ClienteDetalle from './pages/ClienteDetalle';
import Configuracion from './pages/Configuracion';
import CobrosDirectos from './pages/CobrosDirectos';
import Dashboard from './pages/Dashboard';
import Descuentos from './pages/Descuentos';
import Disponibilidades from './pages/Disponibilidades';
import Fidelizacion from './pages/Fidelizacion';
import Inventario from './pages/Inventario';
import LoginPage from './pages/Login';
import Mascotas from './pages/Mascotas';
import Notificaciones from './pages/Notificaciones';
import Pagos from './pages/Pagos';
import Posts from './pages/Posts';
import PushClientes from './pages/PushClientes';
import Reportes from './pages/Reportes';
import Usuarios from './pages/Usuarios';
import Profesionales from './pages/Profesionales';
import Pedidos from './pages/tienda/Pedidos';
import Productos from './pages/tienda/Productos';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/usuarios" element={<Usuarios />} />
              <Route path="/profesionales" element={<Profesionales />} />
              <Route path="/veterinarios" element={<Profesionales />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/atencion" element={<Atencion />} />
              <Route path="/disponibilidades" element={<Disponibilidades />} />
              <Route path="/clientes" element={<Clientes />} />
              <Route path="/clientes/:uuid" element={<ClienteDetalle />} />
              <Route path="/mascotas" element={<Mascotas />} />
              <Route path="/fidelizacion" element={<Fidelizacion />} />
              <Route path="/descuentos" element={<Descuentos />} />
              <Route path="/cobros-directos" element={<CobrosDirectos />} />
              <Route path="/inventario" element={<Inventario />} />
              <Route path="/tienda/productos" element={<Productos />} />
              <Route path="/tienda/pedidos" element={<Pedidos />} />
              <Route path="/pagos" element={<Pagos />} />
              <Route path="/reportes" element={<Reportes />} />
              <Route path="/notificaciones" element={<Notificaciones />} />
              <Route path="/push-clientes" element={<PushClientes />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/configuracion" element={<Configuracion />} />
            </Route>
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>

      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
    </>
  );
}

export default App;
